import React from 'react'
import { CoreButton } from 'src/components/core'

const BackButton = props => {
  const { handleBack } = props
  return (
    <CoreButton variant="outlined" onClick={handleBack} color="secondary">
      Back
    </CoreButton>
  )
}

export default BackButton
